import { Search, VisibilityRounded,CloseRounded as CloseIcon, Edit, Tag } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Autocomplete, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, GridLegacy as Grid, IconButton, Input, Modal, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel, CheckBoxWithLabel, CustomAutoComplete, InputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance, DateFormatString, DateTimeFormatString, DialogType, EntityStatus, FormActions, FormatPrice, Perfiles, TiposOfertas, TiposVehiclos, TipoVehiculoEntity, usuarioEntity } from "../../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador, ModalFormOferta } from "../../../components/form/ModalForm";
import { FilterForm } from "../../../components/form/filter-form";
import axios from "axios";

const schemaFilter = yup.object({
  

}).required();

const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  producto:null,
  tipo_ofertas:null,
  vigentes:'SI',
 
};



const OfertaEntityValue = {
  cod_lista_precio:null,
  cliente_especifico:[],
  cod_clasificacion_cliente:[],
  fecha_desde:dayjs().format(DateFormatString),
  subtipo_cliente:null,
  tamanio_cliente:null,
  fecha_hasta:null,
  fecha_disponibilidad:dayjs().startOf("day").format(DateFormatString),
}

export const MaestroOfertas = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store:{profile}} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState(OfertaEntityValue);
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [clasificacionClientes,setListClasificacionClientes] = useState([]);
  const [centrosOP,setCentrosOp] = useState([]);
  const [productosOptions,setProductosOptions] = useState([]);

  const hasDisabledOptions  =  ![Perfiles.administrador,Perfiles["administrador-punto-venta"]].includes(profile?.perfil?.cod); 
  console.log({hasDisabledOptions,profile:profile?.perfil?.descripcion});


    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);


      let ClasificacionClientResult = await AxiosInstance.post(`maestros-marketplace/get-clasificacion-clientes-filtro/${profile.cod_cia || ''}`);
      setListClasificacionClientes(ClasificacionClientResult.data.value);

      const  {data:{value}} = await AxiosInstance.get(`Sucursales/obtener-centros-operacion-enabled-seller`);
      setCentrosOp(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }
    



    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post(`maestros-marketplace/get-listado-ofertas/${profile.cod_cia || ''}`,{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };


    const getDetalleOffert = async(cod_offerta)=>{
       const  {data:{value}}  = await AxiosInstance.get("maestros-marketplace/get-detale-oferta-from-list/"+cod_offerta);
       return value
    }

    const onShowDetailProduct = async(cod_prod)=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
     try{
      const data =  await getDetalleOffert(cod_prod);

      setIsVisibleModalDetalle(true);
      let product =  dataSetProdctos.find(prod=>prod.cod_oferta === cod_prod);
      
      let newProduct = {
        sync_automatica:product.sync_automatica,
        count_pedidos:product.count_pedidos,
        cod:product.cod_oferta,
        descripcion:product.oferta_descipcion,
        url_imagen:product.url_imagen_producto_imagen,
        es_especial:product.es_especial,
        producto:{
          label:product.cod_erp_producto+" - "+product.nombre_producto,
          value:product.cod_producto,
          url_imagen:product.url_imagen_producto_imagen
        },
        cod_unidad_medida:product.cod_unidad_medida,
        audiencType:product.audiencType,
        cod_clasificacion_cliente:data.clasificacion_clientes,
        cliente_especifico:data.cliente_especifico,
        subtipo_cliente:data.clasificacion_mayores?.subtipo,
        tamanio_cliente:data.clasificacion_mayores?.tamanio,
        precio_sugerido:Number(product.precio_oferta),
        cantidad_maxima_oferta:Number(product.cantidad_maxima_oferta || 0),
        cantidad_minima_oferta:Number(product.cantidad_minima_oferta || 0),
        fecha_desde:product.fecha_desde_oferta,
        fecha_hasta:product.fecha_hasta_oferta,
        fecha_disponibilidad:product.fecha_disponibilidad,
        centros_operacion:data.centros_operaciones


      };
      console.log("prodct",newProduct,cod_prod);
    
      setProductoSeleccionado(newProduct);
      
     
      setTipoAction(FormActions.MODIFICAR);
      onOpenModalItem(true);


     }catch(e){
      console.log(e.message);
      dispatch({
        type:ActionTypes.setModalInfo,
        data:{
            title:"Error",
            message:"Error de comunicacion verifique su conexion a internet",
            type:DialogType.peligro,
            isVisible:true
        }
    });

     }
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
    

    }
    const onCloseModalItem = ()=>{
      setIsVisibleModalDetalle(false);
    }
    const onOpenModalItem = (edit=false)=>{

      if (!edit){
        setProductoSeleccionado(OfertaEntityValue);
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
    
      console.log({typeAction,dataForm});
     
    
      const urlService = typeAction === FormActions.AGREGAR?'maestros-marketplace/create-offert':'maestros-marketplace/edit-oferta/'+dataForm.cod;
 
        let payload =  {
          fecha_desde:dataForm.fecha_desde,
          fecha_hasta:dataForm.fecha_hasta,
          cod_producto:dataForm.producto.value,
          cod_unidad_medida:dataForm.cod_unidad_medida,
          cantidad_minima_oferta:dataForm.cantidad_minima_oferta,
          cantidad_maxima_oferta:dataForm.cantidad_maxima_oferta,
          fecha_disponibilidad:dataForm.fecha_disponibilidad,
          es_especial:dataForm.es_especial,
          tipo_audiencia:dataForm.audiencType,
          centros_operacion:dataForm.centros_operacion.map( item=>({...item,cod:item.agregado?null:item.cod}) )
          };
          
          if( dataForm.audiencType  === 'TIPOS_CLIENTES'  ){
            payload.listado_tipos_clientes = dataForm.cod_clasificacion_cliente.map( item=>item.value );
            payload.listado_clientes = null;
          }
          if( dataForm.audiencType  === 'CLIENTES' ){
            payload.listado_clientes = dataForm.cliente_especifico.map(item=>item.value);
            payload.listado_tipos_clientes = null;
          }
          payload.subtipo_cliente = dataForm.subtipo_cliente;
          payload.tamanio_cliente = dataForm.tamanio_cliente;
          
          
          console.log({payload});
          
        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.put(urlService,payload)
        .then(async res=>{
         //setIsVisibleModalDetalle(false);
          if ( res.data.status ){
            await loadItems(true);
          }else{
            dispatch({
              type:ActionTypes.setModalInfo,
              data:{
                  title:"Error",
                  message:res.data.msg,
                  type:DialogType.peligro,
                  isVisible:true
              }
          });
          
           
          }
        
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }
    const onSearchProducto = async (value_search) => {

      if (value_search) {
         try{
  
          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }
  
    
    const searcProducto = async (event, newInputValue) => {
      try {
        let res = await onSearchProducto(newInputValue);
        setProductosOptions(res);
      } catch (e) {
  
      }
    }

    const  setFilterAply = (filtros)=>{
    
      setFilterSearchPagination({
        ...InitialFilterSearch,
        ...filtros
      });
  
    }
  
    const columnsTable = [
      {
      
       key:"cod_oferta",
       keyValue:"cod_oferta",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"nombre_producto",
        keyValue:"nombre_producto",
        label:"Producto",
        headerRender:(props)=>props.label,
        bodyRender:({value,otherProps})=>otherProps.cod_erp_producto+" - "+value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"producto_commercial_name",
        keyValue:"producto_commercial_name",
        label:"Nombre comercial",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"es_especial",
        keyValue:"es_especial",
        label:"¿Es Especial?",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"sync_automatica",
        keyValue:"sync_automatica",
        label:"¿Es automatica?",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"count_pedidos",
        keyValue:"count_pedidos",
        label:"# Pedidos",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_hasta_oferta",
        keyValue:"fecha_hasta_oferta",
        label:"F. vencimiento",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value?props.value:'N/A',
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
        key:"editar",
        keyValue:"cod_oferta",
        label:"Editar",
        headerRender:(props)=>props.label,
        bodyRender:({value,otherProps})=><Button  onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<Edit/>} >Editar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
      },  
    ];
   
    const configModal =  {
      initialData:{
      centrosOP,
      clasificacionClientes,
      },
      entityValues:productoSeleccionado,
      titleModal: tipoAction === FormActions.AGREGAR? "Agregar  oferta":'Modificar oferta',
      buttomsAction: tipoAction === FormActions.AGREGAR? [
          {
            title:"Cancelar",
            buttomProps:{
              type:"buttom",
              onClick:()=>setIsVisibleModalDetalle(false),
              color:"secondary"
          }
          },
          {
            title:"Registrar",
            buttomProps:{ 
              type:"submit",
              disabled:hasDisabledOptions
             // onClick:onSaveDataNewData
            }
          }
      ]:[
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
            disabled:hasDisabledOptions
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[]
    } ;


    const InputFilters = [
      {
        grid:{
          xs:2,
          md:2,
          sm:2
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"producto",
        InputComponentProps:{
          label:"Producto",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',

          onInputChange: searcProducto,
          options: productosOptions || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      },
      {
        grid:{
          xs:2,
          md:2,
          sm:2
        },
      
        InputComponent:SelectInputWithLabel,
        keyValue:"tipo_ofertas",
        items: [
          {label:"Todas",value:null}
        ].concat(Object.keys(TiposOfertas).map( key=>({value:key,label:TiposOfertas[key]}) )),
        InputComponentProps:{
          label:"Tipo de ofertas",
          fullWidth:true,
          isLoading:false,
          size:'small',
          value:true
        }
      },
      {
        grid:{
          xs:2,
          md:2,
          sm:2
        },
      
        InputComponent:SelectInputWithLabel,
        keyValue:"vigentes",
        items: [
          {label:"Todos",value:null},
          {label:"SI",value:'SI'},
          {label:"NO",value:'NO'}
        ],
        InputComponentProps:{
          label:"¿Vigentes?",
          fullWidth:true,
          isLoading:false,
          size:'small',
          value:true
        }
      },
    
    
    ];




    console.log({profile});


    return (<>
    {
      isVisibleModalDetalle &&
    <ModalFormOferta 
    isVisible={isVisibleModalDetalle}
 
   
    {
      ...configModal
    }
    onSendForm={onSaveDataForm}
    typeAction={tipoAction}
    />
    }
   
    <Grid container spacing={2} >

    <Grid item sm={12} xs={12} md={12} >
        <FilterForm
            buttomDist={
              {
                sx:2,
                md:2
              }
            }
           
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={
              filterSearchPagination
            }
            onApplyFilter={setFilterAply}
          />
        </Grid>

        <Grid item sm={12} xs={12} md={12} >
          <Button  disabled={hasDisabledOptions}  variant="contained" color="primary" onClick={e=>onOpenModalItem(false)} >Nueva oferta</Button>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender otherProps={prod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}